module.exports = __webpack_public_path__ + "img/17_24.e2488c53.png";